document.addEventListener('DOMContentLoaded',()=>{
  const root=document.querySelector('[data-js-refill]');if(!root)return;
  const selected=new Map();
  const toast=root.querySelector('[data-toast]');let toastTimer;
  const notify=message=>{if(!toast)return;toast.textContent=message;toast.classList.add('is-visible');clearTimeout(toastTimer);toastTimer=setTimeout(()=>toast.classList.remove('is-visible'),3000)};
  const activateTab=name=>{
    root.querySelectorAll('[data-tab]').forEach(item=>item.classList.toggle('is-active',item.dataset.tab===name));
    root.querySelectorAll('[data-view]').forEach(view=>view.classList.toggle('is-active',view.dataset.view===name));
  };
  root.querySelectorAll('[data-tab]').forEach(button=>button.addEventListener('click',()=>activateTab(button.dataset.tab)));

  const requestedVariant=new URLSearchParams(window.location.search).get('variant');
  const cards=[...root.querySelectorAll('[data-customer-products] [data-product]')];
  const requestedCard=requestedVariant?cards.find(card=>card.dataset.variant===requestedVariant):null;
  const activeCard=requestedCard||cards[0];
  const quickHost=root.querySelector('[data-quick-host]');
  if(quickHost&&activeCard){
    const variantLabel=activeCard.dataset.variantTitle&&activeCard.dataset.variantTitle!=='Default Title'?` · ${activeCard.dataset.variantTitle}`:'';
    quickHost.innerHTML=`<article class="jsr__quick" data-product data-variant="${activeCard.dataset.variant}" data-title="${activeCard.dataset.title}"><div class="jsr__quick-info">${activeCard.dataset.image?`<img class="jsr__quick-image" src="${activeCard.dataset.image}" alt="">`:''}<div><span class="jsr__eyebrow">Direkt nachbestellen</span><h2>${activeCard.dataset.title}</h2><span class="jsr__muted">Art.-Nr. ${activeCard.dataset.sku}${variantLabel}</span><p class="jsr__price">${activeCard.dataset.price}</p><div class="jsr__last-order"><span>Letzte Bestellung: ${activeCard.dataset.lastOrder}</span><strong>Letzte Menge: ${activeCard.dataset.lastQuantity}</strong></div></div></div><div class="jsr__controls"><input class="jsr__qty" type="number" min="1" value="${Math.max(1,Number.parseInt(activeCard.dataset.lastQuantity,10)||1)}" aria-label="Menge" data-qty><button class="jsr__button" type="button" data-add>Hinzufügen</button></div></article>`;
    if(requestedCard)notify(`${requestedCard.dataset.title} – ${requestedCard.dataset.variantTitle||'Variante'} ist bereit zum Nachbestellen`);
  }else if(quickHost){
    quickHost.innerHTML='<div class="jsr__empty">In Ihren Bestellungen wurden noch keine passenden Verbrauchsartikel gefunden.</div>';
  }

  root.querySelectorAll('[data-customer-login]').forEach(link=>{
    const returnTo=`${window.location.pathname}${window.location.search}`;
    const join=link.href.includes('?')?'&':'?';
    link.href=`${link.href}${join}return_url=${encodeURIComponent(returnTo)}`;
  });
  let printSheet;
  const cleanupPrintSheet=()=>{
    document.body.classList.remove('jsr-printing');
    printSheet?.remove();
    printSheet=undefined;
  };
  root.querySelector('[data-print-labels]')?.addEventListener('click',()=>{
    cleanupPrintSheet();
    const source=root.querySelector('.jsr__labels');if(!source)return;
    printSheet=document.createElement('main');
    printSheet.className='jsr-print-sheet';
    const labels=source.cloneNode(true);
    const originalQrCodes=source.querySelectorAll('.jsr__qr');
    labels.querySelectorAll('.jsr__qr').forEach((qr,index)=>{
      const original=originalQrCodes[index];if(!original)return;
      const renderedImage=original.querySelector('img[src]');
      const renderedCanvas=original.querySelector('canvas');
      const image=document.createElement('img');
      image.src=renderedImage?.src||renderedCanvas?.toDataURL('image/png')||'';
      image.alt=renderedImage?.alt||'QR-Code';
      qr.replaceChildren(image);
    });
    printSheet.append(labels);
    document.body.append(printSheet);
    document.body.classList.add('jsr-printing');
    requestAnimationFrame(()=>window.print());
  });
  window.addEventListener('afterprint',cleanupPrintSheet);
  root.addEventListener('click',event=>{
    const add=event.target.closest('[data-add]');if(!add)return;
    const card=add.closest('[data-product]');const input=card.querySelector('[data-qty]');const quantity=Math.max(1,Number.parseInt(input.value,10)||1);const variant=Number(card.dataset.variant);const title=card.dataset.title;
    selected.set(variant,{id:variant,quantity:(selected.get(variant)?.quantity||0)+quantity,title});
    root.querySelector('[data-cart-count]').textContent=[...selected.values()].reduce((sum,item)=>sum+item.quantity,0);
    notify(`${title} wurde vorgemerkt`);
  });
  root.querySelector('[data-submit-cart]')?.addEventListener('click',async()=>{
    if(!selected.size){notify('Bitte zuerst mindestens einen Artikel auswählen.');return;}
    const button=root.querySelector('[data-submit-cart]');button.disabled=true;button.textContent='Wird übertragen …';
    try{
      const response=await fetch(`${window.Shopify.routes.root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[...selected.values()].map(({id,quantity})=>({id,quantity,properties:{'_JS Refill':'Kundenportal'}}))})});
      if(!response.ok)throw new Error();
      await fetch(`${window.Shopify.routes.root}cart/update.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({attributes:{'JS Refill Quelle':'Kundenportal'}})}).catch(()=>{});
      window.location.assign(`${window.Shopify.routes.root}cart`);
    }catch{button.disabled=false;button.textContent='An Shopify übergeben';notify('Die Warenkorbübergabe ist gerade nicht möglich.')}
  });
});
